import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

import { MathEnabledTextComponent, getSize, getColor } from '@lib/common';
import { QuestionType } from '@module/form';
import styled, { getShadow } from '@xstyled/styled-components';
import { Space } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useQuestionContext } from '../core';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  position: relative;\n  box-shadow: ", ";\n  background-color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n\n  border-width: 1px 1px 1px 6px;\n  border-style: solid;\n  border-color: ", ";\n\n  transition: border-color 0.3s ease;\n"])), getSize('padding16'), getShadow('shadow1'), getColor('fillBgWhite'), getSize('padding24'), getSize('radiusSm'), function (_ref) {
  var $selected = _ref.$selected;
  return $selected ? getColor('fillIntActive') : '#cbd5e1';
});
var StyledQuestionHeader = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  width: 100%;\n"])));
var StyledQuestionNumberTag = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n"])), getSize('padding4'), getSize('padding8'), getSize('typo14'), getSize('typo20'), getColor('fillIntActive'), getSize('radiusS'));
var StyledQuestionTypeTag = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: flex-start;\n\n  gap: ", ";\n\n  font-size: ", ";\n  font-weight: 600;\n  color: #728096;\n  border-radius: ", ";\n  border: 1px solid #e5e7eb;\n  padding: 6px ", ";\n  line-height: 1rem;\n"])), getSize('padding8'), getSize('typo14'), getSize('radiusRounded'), getSize('padding8'));
var StyledQuestionDescription = styled(MathEnabledTextComponent)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: #1e293b;\n  line-height: ", ";\n  font-weight: 400;\n\n  letter-spacing: 0;\n  cursor: pointer;\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), getSize('typo14'), getSize('padding20'));
var StyledExplanationWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n\n  width: 100%;\n  padding: ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid #e2e8f0;\n"])), getSize('padding4'), getSize('padding12'), getSize('radiusSm'));
var StyledExplanationIconWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'));
var StyledExplanationTitle = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.5;\n"])), getSize('typo16'));
var StyledExplanationContent = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding4'));
var StyledExplanationDescription = styled(MathEnabledTextComponent)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ", ";\n  letter-spacing: 0;\n  line-height: 1.6;\n  color: #475569;\n\n  img {\n    max-width: 100%;\n    border-radius: ", ";\n    margin: ", " 0;\n  }\n\n  strong {\n    font-weight: 600;\n    &:not([style*='color']) {\n      color: #1e293b;\n    }\n  }\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n\n    &:hover {\n      color: #6d28d9;\n    }\n  }\n"])), getSize('typo14'), getSize('radiusSm'), getSize('padding12'), getColor('fillIntActive'));
var DESCRIPTION_COLLAPSED_MAX_HEIGHT = 96;
var StyledDescriptionContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  max-height: ", ";\n  transition: max-height 0.3s ease;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 56px;\n    background: linear-gradient(to bottom, transparent, #ffffff);\n    pointer-events: none;\n    opacity: ", ";\n    transition: opacity 0.3s ease;\n  }\n"])), function (_ref2) {
  var $expanded = _ref2.$expanded;
  return $expanded ? 'none' : "".concat(DESCRIPTION_COLLAPSED_MAX_HEIGHT, "px");
}, function (_ref3) {
  var $expanded = _ref3.$expanded,
      $hasOverflow = _ref3.$hasOverflow;
  return !$expanded && $hasOverflow ? 1 : 0;
});
var StyledReadMoreButton = styled.button(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 2px;\n  padding: ", " 0 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.5;\n\n  &:hover span {\n    text-decoration: underline;\n  }\n"])), getSize('padding4'), getSize('typo14'), getColor('fillIntActive'));
var StyledChevron = styled.svg(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  transition: transform 0.3s ease;\n  transform: ", ";\n"])), function (_ref4) {
  var $expanded = _ref4.$expanded;
  return $expanded ? 'rotate(180deg)' : 'rotate(0deg)';
}); // Helper function to check if explanation is empty (after removing HTML tags and whitespace)

var isExplanationEmpty = function isExplanationEmpty(explanation) {
  if (!explanation) return true; // Trim whitespace first

  var trimmedExplanation = explanation.trim();
  if (!trimmedExplanation) return true; // Check if explanation has images

  var hasImage = /<img[^>]+>/gi.test(trimmedExplanation);
  if (hasImage) return false; // Not empty if has image
  // Remove all whitespace

  var contentWithoutWhitespace = trimmedExplanation.replace(/\s/g, ''); // Remove all HTML tags

  var htmlTagRegex = /(<([^>]+)>)/gi;
  var formattedContentWithoutHTML = contentWithoutWhitespace.replaceAll(htmlTagRegex, ''); // Check if content is empty after removing HTML and whitespace

  return !formattedContentWithoutHTML || formattedContentWithoutHTML.length === 0;
};

export var BaseQuestionReportComponent = function BaseQuestionReportComponent(_ref5) {
  var states = _ref5.states,
      actions = _ref5.actions,
      children = _ref5.children;
  var isSelected = states.isSelected,
      label = states.label,
      icon = states.icon,
      customDescription = states.customDescription,
      hideExplanation = states.hideExplanation;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var _useState = useState(false),
      isDescriptionExpanded = _useState[0],
      setIsDescriptionExpanded = _useState[1];

  var descriptionContainerRef = useRef(null);

  var _useState2 = useState(false),
      hasDescriptionOverflow = _useState2[0],
      setHasDescriptionOverflow = _useState2[1];

  useEffect(function () {
    setIsDescriptionExpanded(false);
  }, [question.description]);
  useEffect(function () {
    var el = descriptionContainerRef.current;
    if (!el || isDescriptionExpanded) return;

    var checkOverflow = function checkOverflow() {
      setHasDescriptionOverflow(el.scrollHeight > el.clientHeight);
    };

    var timeoutId = setTimeout(checkOverflow, 0);
    var observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    return function () {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [question.description, isDescriptionExpanded]);
  var hasExplanation = useMemo(function () {
    return !isExplanationEmpty(question.explanation);
  }, [question.explanation]);
  var questionTypeTagLabel = useMemo(function () {
    var _questionTypeTagLabel;

    var questionTypeTagLabelMapping = (_questionTypeTagLabel = {}, _defineProperty(_questionTypeTagLabel, QuestionType.SingleChoice, (label === null || label === void 0 ? void 0 : label.singleChoice) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.FillInBlank, (label === null || label === void 0 ? void 0 : label.fillInBlank) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Matching, (label === null || label === void 0 ? void 0 : label.matching) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.Essay, (label === null || label === void 0 ? void 0 : label.essay) || ''), _defineProperty(_questionTypeTagLabel, QuestionType.MultipleChoice, (label === null || label === void 0 ? void 0 : label.multipleChoice) || ''), _questionTypeTagLabel);
    return questionTypeTagLabelMapping[question.type] || (label === null || label === void 0 ? void 0 : label.unknownQuestion) || 'Unknown';
  }, [question.type, label]);
  return /*#__PURE__*/_jsxs(StyledLayout, {
    id: question.id.toString(),
    $selected: isSelected // onClick={() => onSelectQuestion(question.id.toString())}
    ,
    children: [/*#__PURE__*/_jsx(StyledQuestionHeader, {
      children: /*#__PURE__*/_jsxs(Space, {
        size: 12,
        children: [/*#__PURE__*/_jsxs(StyledQuestionNumberTag, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsxs(StyledQuestionTypeTag, {
          children: [icon.pointFocus, /*#__PURE__*/_jsx("span", {
            children: questionTypeTagLabel
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      children: customDescription !== null && customDescription !== void 0 ? customDescription : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(StyledDescriptionContainer, {
          ref: descriptionContainerRef,
          $expanded: isDescriptionExpanded,
          $hasOverflow: hasDescriptionOverflow,
          children: /*#__PURE__*/_jsx(StyledQuestionDescription, {
            value: question.description
          })
        }), (hasDescriptionOverflow || isDescriptionExpanded) && /*#__PURE__*/_jsxs(StyledReadMoreButton, {
          onClick: function onClick(e) {
            e.stopPropagation();
            setIsDescriptionExpanded(function (prev) {
              return !prev;
            });
          },
          children: [/*#__PURE__*/_jsx("span", {
            children: isDescriptionExpanded ? label.readLess : label.readMore
          }), /*#__PURE__*/_jsx(StyledChevron, {
            $expanded: isDescriptionExpanded,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/_jsx("path", {
              d: "M4 6L8 10L12 6",
              stroke: "currentColor",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })]
        })]
      })
    }), children && /*#__PURE__*/_jsx(_Fragment, {
      children: children
    }), !hideExplanation && hasExplanation && /*#__PURE__*/_jsxs(StyledExplanationWrapper, {
      children: [/*#__PURE__*/_jsx(StyledExplanationIconWrapper, {
        children: icon.lightBulb
      }), /*#__PURE__*/_jsxs(StyledExplanationContent, {
        children: [/*#__PURE__*/_jsx(StyledExplanationTitle, {
          children: label.explanation
        }), /*#__PURE__*/_jsx(StyledExplanationDescription, {
          value: question.explanation
        })]
      })]
    })]
  });
};